import type { ComponentDocMap } from './types'

/**
 * Prop documentation for the `followup_production` anchor component.
 * Keep in sync with FollowupProductionProps in src/ui/uiConfig/anchorComponents/FollowupProduction/FollowupProduction.types.ts
 */
export const followupProductionPropDocs: ComponentDocMap = {
  headerTabs: {
    description: 'Header tabs grouping one or more follow-up comparison tabs.',
    type: 'FollowupProductionHeaderTab[]',
  },
  'headerTabs[].title': { description: 'Header tab title.', type: 'string' },
  'headerTabs[].headerTabKpi': {
    description: 'Optional KPI widget rendered in header context.',
    type: 'FollowupProductionCell',
  },
  'headerTabs[].tabs': {
    description: 'Comparison tabs shown under the header tab.',
    type: 'FollowupProductionTab[]',
  },
  'headerTabs[].tabs[].title': { description: 'Sub-tab title.', type: 'string' },
  'headerTabs[].tabs[].kpi': { description: 'KPI cell definition.', type: 'FollowupProductionCell' },
  'headerTabs[].tabs[].total_cost': {
    description: 'Total cost cell definition.',
    type: 'FollowupProductionCell',
  },
  'headerTabs[].tabs[].total_production': {
    description: 'Total production cell definition.',
    type: 'FollowupProductionCell',
  },
  'headerTabs[].tabs[].optimal': { description: 'Optimal plan cell.', type: 'FollowupProductionCell' },
  'headerTabs[].tabs[].outcome': { description: 'Outcome/actual cell.', type: 'FollowupProductionCell' },
  'headerTabs[].tabs[].applied_settings_values': {
    description:
      "Optional applied setting values cell. It renders no UI config: the settings come from the digital twin and BaseConfig. Its (or the header tab's) `override_alias` needs only `optjob_type`; the rest defaults as in Collected settings. `optimal_optjob_type` defaults to `optjob_type`, `outcome_optjob_type` to `measvalues_calculations`, the `*_opt_job_type_id` aliases to the id of their opt job type, and `priority_levels` to the levels the system configures for the optimal opt job type, or for the subtypes `optjob_subtype` names, hidden levels left out. `optjob_subtype` (a subtype or a list) limits the optimal run's subtypes; without it the run takes every subtype the system lists for its opt job type. Any alias the cell sets itself replaces its default. With a header filter the page's settings follow it, and without one all settings at the priority levels show.",
    type: '{ title?: string; override_alias?: UiConfigAliases }',
  },
  'headerTabs[].tabs[].extra': { description: 'Optional extra cell.', type: 'FollowupProductionCell' },
  'headerTabs[].tabs[].extra_2': { description: 'Optional second extra cell.', type: 'FollowupProductionCell' },
  'headerTabs[].override_alias': { description: 'Alias overrides for this header tab.', type: 'UiConfigAliases' },
  'headerTabs[].override_props': {
    description: 'Prop overrides for this header tab.',
    type: 'UiConfigOverrideProps',
  },
  'headerTabs[].tabs[].kpi.ui_config_id': { description: 'Child ui_config id.', type: 'number' },
  'headerTabs[].tabs[].kpi.title': { description: 'Optional cell title.', type: 'string' },
  'headerTabs[].tabs[].kpi.override_alias': { description: 'Cell-level alias override.', type: 'UiConfigAliases' },
  'headerTabs[].tabs[].kpi.override_props': {
    description: 'Cell-level prop override.',
    type: 'UiConfigOverrideProps',
  },
}
